<template>
  <div class="footer" ref="footer" id="home-footer">
    <div class="footer-top">
      <div class="content">
        <div class="left">
          <a :href="index2_path" class="logo"><img :src="static_img_url + 'pic/logo-vcbeat.png?v=3922'" alt="动脉网logo"></a>
          <p class="p1">全球产业链接平台</p>
          <p class="p2">重庆市两江新区礼嘉金泰智能产业园二期15栋601</p>
          <p class="p2">联系电话：023-67139735（重庆）</p>
        </div>
        <div class="center">
          <div class="link">
            <div class="link-title">关于我们</div>
            <div class="link-list">
              <div><a :href="index2_path + '/Index/Index/companyInfo'" target="_blank">关于我们</a></div>
              <div><a :href="index2_path + '/Index/Index/aboutUs'" target="_blank">联系我们</a></div>
              <div><a href="https://vcbeat.zhiye.com/Campus" target="_blank">加入我们</a></div>
              <div><a href="https://support.qq.com/products/340682" target="_blank" rel="nofollow">意见反馈</a></div>
            </div>
          </div>
          <div class="link">
            <div class="link-title">产品服务</div>
            <div class="link-list link-list2">
              <div><a :href="index2_path + '/intelList'" target="_blank">7x24H产业情报</a></div>
              <!-- <div><a :href="index2_path + '/VBResearch'" target="_blank">蛋壳研究院</a></div> -->
              <div><a :href="index2_path + '/home/linkIndex'" target="_blank">动脉产业链接</a></div>
              <div><a @click="handleClickProExperience">动脉智库</a></div>
              <div><a :href="vcbeat_path + '/Form/compContact'" target="_blank">企业对接</a></div>
              <div><a :href="index2_path + '/IndustrialSolutions'" target="_blank">行业解决方案</a></div>
              <div><a :href="index2_path + '/home/liveList'" target="_blank">直播</a></div>
              <div><a :href="vbef_path" target="_blank">未来医药医药100强展会</a></div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="ewm-item">
            <img :src="static_img_url + 'pic/footer-shangwuhezuo.png'" />
            <p>商务合作</p>
          </div>
          <div class="ewm-item">
            <img :src="static_img_url + 'pic/download-code-pcfooter.png'" />
            <p>动脉网APP</p>
          </div>
        </div>
      </div>
      <div class="inter-link">
        <p class="title">友情链接</p>
        <div class="links">
          <a v-for="item,index in links" :key="index" :href="item.link_url" target="_blank">
            <img :src="item.img_path | logo_show" :alt="item.title">
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <a href="http://beian.miit.gov.cn" target="_blank">© 动脉橙 渝ICP备18013108号</a>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50011202502165">
        <img :src="$store.state.img_req_url + '/upload/vcbeat/public/images/pb-icon.png'" />
        渝公网安备 50011202502165号
      </a>
      <a href="javascript:void(0)" @click="certificate_model = true">互联网药品信息服务资格证书：（渝）-非经营性-2023-0083</a>
    </div>
    <Modal class="certificate-model" v-model="certificate_model" width="960" :footer-hide="true">
      <img :src="static_img_url + 'pic/certificate.jpg'" class="certificate-img" />
    </Modal>
  </div>
</template>

<script>
import { getFriendlyLinks } from '@/service'
import { mapState } from 'vuex'
export default {
  inject: ['handleClickProExperience'],
  data() {
    return {
      certificate_model: false,
      links: []
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index2_path: (state) => state.index2_path,
      index_path: (state) => state.index_path,
      vbef_path: (state) => state.vbef_path,
      img_req_url: (state) => state.img_req_url,
    })
  },
  methods: {
    async getFriendlyLinks() {
      let res = await getFriendlyLinks({}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'links', res.res)
      } else {
        console.log(res)
      }
    }
  },
  created() {
    this.getFriendlyLinks()
  }
}
</script>

<style lang="stylus" scoped>
.footer
  width 100%
  min-width 1200px
  border-top 1px #e0e0e0 solid
  background: #FFFFFF
  .footer-top
    width 1200px
    margin 0 auto
    padding 50px 0 30px
    .content
      display flex
      justify-content space-between
      align-items flex-end
      .left
        .logo
          display block
          width 121px
          height 30px
          font-size 0
          img
            width 100%
            height 100%
        .p1
          font-size 22px
          font-weight 400
          color #333333
          line-height 32px
          margin-top 28px
          &+.p2
            margin-top 32px
        .p2
          font-size 14px
          font-weight 400
          color #333333
          line-height 20px
          &+.p2
            margin-top 20px
      .center
        display flex
        margin-left 100px
        .link
          .link-title
            font-size 16px
            color #333333
            line-height 22px
            font-weight bold
          .link-list
            padding-top 7px
            width 150px
            > div
              margin-top 20px
            a
              font-size 14px
              color #333333
              line-height 20px
              transition all 0.3s
              cursor pointer
              &:hover
                color #FA5A00
            &.link-list2
              display flex
              flex-wrap wrap
              width 300px
              > div
                flex 0 0 150px
      .right
        display flex
        .ewm-item
          flex 0 0 120px
          display flex
          flex-direction column
          align-items center
          &+div
            margin-left 40px
          img
            width 120px
            height 120px
          p
            font-size 14px
            font-weight 400
            color #6D6D6D
            line-height 20px
            margin-top 10px
    .inter-link
      margin-top 30px
      line-height 1
      .title
        color #333
        font-size 14px
        margin-bottom 0
        font-weight 800
        line-height 1
      .links
        margin-top 15px
        display grid
        grid-template-columns repeat(13, 80px)
        grid-row-gap 10px
        grid-column-gap 10px
        a
          font-size 14px
          margin-right 0
          margin-bottom 0
          color #999
          line-height 1
          width auto
          height 40px
          display flex
          justify-content center
          align-items center
          border 1px solid #e9e9e9
          padding 4px
          border-radius 2px
          cursor pointer
          overflow hidden
          transition all 0.3s
          img
            max-width 100%
            max-height 100%
          &:hover
            border-color #FA5A00
  .footer-bottom
    width 100%
    height 48px
    background #000
    text-align center
    display flex
    align-items center
    justify-content center
    a
      font-size 12px
      color #fff
      display flex
      align-items center
      img
        margin-right 5px
        width 16px
      &+a
        margin-left 20px
      &:hover
        color #FA5A00
.certificate-model
  >>> .ivu-modal-content
    border-radius 0
    .ivu-modal-close
      .ivu-icon-ios-close
        color #fff
    .ivu-modal-body
      padding 0
      font-size 0
.certificate-img
  width 100%
</style>
